module.exports = __webpack_public_path__ + "static/media/bank.cf3cc24b.png";